<template>
	<symbol :id="`${prefix}blank`" viewBox="0 0 16 16"></symbol>
</template>

<script>
export default {
	name: 'NiIconSymbolBlank',

	props: {
		prefix: {
			type: String,
			required: true,
		},
	},
};
</script>
